/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

;(function () {
  'use strict';

  var DOMINIO_PUBLICO = 'https://www.tecnova.hn';

  function normalizar(texto) {
    return (texto || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  function asignarValorReal(campo, valor) {
    if (!campo) return;

    try {
      campo.focus({ preventScroll: true });
    } catch (error) {
      campo.focus();
    }

    var prototipo =
      campo.tagName === 'TEXTAREA'
        ? window.HTMLTextAreaElement.prototype
        : window.HTMLInputElement.prototype;

    var descriptor = Object.getOwnPropertyDescriptor(
      prototipo,
      'value'
    );

    if (descriptor && descriptor.set) {
      descriptor.set.call(campo, valor);
    } else {
      campo.value = valor;
    }

    campo.setAttribute('value', valor);

    try {
      campo.dispatchEvent(
        new InputEvent('input', {
          bubbles: true,
          inputType: 'insertText',
          data: valor
        })
      );
    } catch (error) {
      campo.dispatchEvent(
        new Event('input', { bubbles: true })
      );
    }

    campo.dispatchEvent(
      new Event('change', { bubbles: true })
    );

    campo.dispatchEvent(
      new KeyboardEvent('keyup', {
        bubbles: true,
        key: 'Unidentified'
      })
    );

    campo.classList.add(
      'is-filled',
      'has-value',
      'filled'
    );

    var contenedor =
      campo.closest(
        '.form-group, .form-field, .field, ' +
        '.input-group, .contact-form__field'
      ) || campo.parentElement;

    if (contenedor) {
      contenedor.classList.add(
        'is-filled',
        'has-value',
        'filled'
      );
    }

    setTimeout(function () {
      campo.blur();
    }, 100);
  }

  function encontrarCampoProducto() {
    var campos = document.querySelectorAll(
      'input:not([type="hidden"]), textarea'
    );

    for (var i = 0; i < campos.length; i += 1) {
      var descripcion = normalizar(
        (campos[i].name || '') + ' ' +
        (campos[i].id || '') + ' ' +
        (campos[i].placeholder || '') + ' ' +
        (campos[i].getAttribute('aria-label') || '')
      );

      if (
        descripcion.indexOf('producto') !== -1 &&
        descripcion.indexOf('interes') !== -1
      ) {
        return campos[i];
      }
    }

    return null;
  }

  function encontrarCampoMensaje() {
    var campos = document.querySelectorAll('textarea');

    for (var i = 0; i < campos.length; i += 1) {
      var descripcion = normalizar(
        (campos[i].name || '') + ' ' +
        (campos[i].id || '') + ' ' +
        (campos[i].placeholder || '') + ' ' +
        (campos[i].getAttribute('aria-label') || '')
      );

      if (
        descripcion.indexOf('mensaje') !== -1 ||
        descripcion.indexOf('body') !== -1
      ) {
        return campos[i];
      }
    }

    return null;
  }

  function cambiarTextoCampoMensaje(campoMensaje) {
    if (!campoMensaje) return;

    var nuevoTexto = 'Escribe tu mensaje aquí...';

    /*
     * Mantener el campo completamente vacío.
     */
    campoMensaje.value = '';
    campoMensaje.removeAttribute('value');

    /*
     * Usar un espacio como placeholder para evitar
     * que el texto aparezca duplicado.
     */
    campoMensaje.setAttribute('placeholder', ' ');

    /*
     * Mantener una descripción para accesibilidad.
     */
    campoMensaje.setAttribute(
      'aria-label',
      nuevoTexto
    );

    /*
     * Cambiar únicamente la etiqueta flotante.
     */
    var etiquetas = document.querySelectorAll('label');

    for (var i = 0; i < etiquetas.length; i += 1) {
      var textoEtiqueta = normalizar(
        etiquetas[i].textContent
      );

      if (
        (
          campoMensaje.id &&
          etiquetas[i].htmlFor === campoMensaje.id
        ) ||
        textoEtiqueta === 'tu mensaje' ||
        textoEtiqueta ===
          'escribe tu mensaje aqui...'
      ) {
        etiquetas[i].textContent = nuevoTexto;
      }
    }

    campoMensaje.dispatchEvent(
      new Event('input', { bubbles: true })
    );

    campoMensaje.dispatchEvent(
      new Event('change', { bubbles: true })
    );
  }

  function guardarEnlaceOculto(
    campoProducto,
    enlace
  ) {
    if (!campoProducto || !enlace) return;

    var formulario =
      campoProducto.closest('form') ||
      document.querySelector(
        'form[action*="/contact"]'
      );

    if (!formulario) return;

    var campoEnlace = formulario.querySelector(
      'input[data-tecnova-enlace-producto]'
    );

    if (!campoEnlace) {
      campoEnlace = document.createElement('input');
      campoEnlace.type = 'hidden';
      campoEnlace.name =
        'contact[Enlace del producto]';

      campoEnlace.setAttribute(
        'data-tecnova-enlace-producto',
        'true'
      );

      formulario.appendChild(campoEnlace);
    }

    campoEnlace.value = enlace;
  }

  function obtenerProductoActual() {
    var tituloElemento =
      document.querySelector('h1');

    var tituloSocial = document.querySelector(
      'meta[property="og:title"]'
    );

    var tituloProducto = '';

    if (
      tituloElemento &&
      tituloElemento.textContent.trim()
    ) {
      tituloProducto =
        tituloElemento.textContent.trim();
    } else if (
      tituloSocial &&
      tituloSocial.content.trim()
    ) {
      tituloProducto =
        tituloSocial.content.trim();
    }

    if (!tituloProducto) return null;

    /*
     * Utilizar solamente el nombre antes
     * del primer separador |.
     */
    tituloProducto =
      tituloProducto.split('|')[0].trim();

    /*
     * Limitar nombres demasiado largos.
     */
    if (tituloProducto.length > 70) {
      tituloProducto =
        tituloProducto
          .substring(0, 67)
          .trim() + '...';
    }

    return {
      nombre: tituloProducto,
      enlace:
        DOMINIO_PUBLICO +
        window.location.pathname
    };
  }

  function prepararBotonesCotizacion() {
    var ruta =
      window.location.pathname.replace(/\/+$/, '');

    if (ruta.indexOf('/products/') === -1) {
      return;
    }

    var productoActual =
      obtenerProductoActual();

    if (!productoActual) return;

    var destinoCotizacion =
      '/pages/pedidos-especiales?producto=' +
      encodeURIComponent(productoActual.nombre) +
      '&enlace=' +
      encodeURIComponent(productoActual.enlace);

    var botones = document.querySelectorAll(
      'a[href*="/pages/pedidos-especiales"]'
    );

    for (var i = 0; i < botones.length; i += 1) {
      var textoBoton = normalizar(
        botones[i].textContent
      );

      if (
        textoBoton.indexOf('solicitar') !== -1 &&
        textoBoton.indexOf('cotiz') !== -1
      ) {
        botones[i].setAttribute(
          'href',
          destinoCotizacion
        );
      }
    }
  }

  function completarFormulario() {
    var ruta =
      window.location.pathname.replace(/\/+$/, '');

    if (
      ruta.indexOf(
        '/pages/pedidos-especiales'
      ) === -1
    ) {
      return;
    }

    var parametros = new URLSearchParams(
      window.location.search
    );

    var producto =
      parametros.get('producto');

    var enlace =
      parametros.get('enlace');

    var campoProducto =
      encontrarCampoProducto();

    var campoMensaje =
      encontrarCampoMensaje();

    /*
     * Colocar el nombre en Producto de Interés.
     */
    if (producto && campoProducto) {
      asignarValorReal(
        campoProducto,
        producto
      );

      /*
       * Guardar el enlace público de forma oculta.
       */
      guardarEnlaceOculto(
        campoProducto,
        enlace
      );
    }

    /*
     * Dejar el mensaje vacío y cambiar
     * solamente su etiqueta flotante.
     */
    cambiarTextoCampoMensaje(
      campoMensaje
    );
  }

  function iniciarCotizacionUniversal() {
    try {
      prepararBotonesCotizacion();

      /*
       * Esperar a que el formulario termine
       * de cargar sus efectos visuales.
       */
      setTimeout(
        completarFormulario,
        250
      );
    } catch (error) {
      console.error(
        'Error en cotización universal:',
        error
      );
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      iniciarCotizacionUniversal
    );
  } else {
    iniciarCotizacionUniversal();
  }
})();










;(function () {
  'use strict';

  if (window.TECNOVA_BUSQUEDA_ACTIVA) return;
  window.TECNOVA_BUSQUEDA_ACTIVA = true;

  var MINIMO_CARACTERES = 2;
  var LIMITE_RESULTADOS = 8;
  var ESPERA_BUSQUEDA = 280;
  var cache = Object.create(null);

  function agregarEstilos() {
    if (
      document.getElementById(
        'tecnova-busqueda-estilos'
      )
    ) {
      return;
    }

    var estilos = document.createElement('style');

    estilos.id = 'tecnova-busqueda-estilos';

    estilos.textContent = [
      '.tn-search-form .search-bar__top{position:relative!important}',

      '.tn-search-results{display:none!important;position:absolute!important;top:calc(100% + 6px)!important;left:0!important;right:0!important;width:100%!important;max-height:min(72vh,620px)!important;overflow-y:auto!important;background:#fff!important;border:1px solid #e2e7f0!important;border-radius:10px!important;box-shadow:0 14px 36px rgba(20,42,94,.18)!important;z-index:99999!important;padding:0!important;opacity:0!important;visibility:hidden!important;pointer-events:none!important;transform:none!important}',

      '.tn-search-results.is-visible{display:block!important;opacity:1!important;visibility:visible!important;pointer-events:auto!important}',

      '.tn-search-status{padding:20px!important;text-align:center!important;color:#657080!important;font-size:14px!important}',

      '.tn-search-heading{padding:12px 16px 8px!important;color:#647081!important;font-size:12px!important;font-weight:700!important;letter-spacing:.04em!important;text-transform:uppercase!important}',

      '.tn-search-list{display:block!important;margin:0!important;padding:0!important;list-style:none!important}',

      '.tn-search-result{display:grid!important;grid-template-columns:64px minmax(0,1fr) auto!important;gap:12px!important;align-items:center!important;padding:11px 16px!important;border-top:1px solid #eef1f6!important;text-decoration:none!important;background:#fff!important;color:#13296b!important}',

      '.tn-search-result:hover,.tn-search-result.is-active{background:#f6f8fd!important}',

      '.tn-search-result__image{display:block!important;width:64px!important;height:64px!important;object-fit:contain!important;object-position:center!important;background:#fff!important;border:0!important;border-radius:4px!important}',

      '.tn-search-result__content{min-width:0!important}',

      '.tn-search-result__title{display:-webkit-box!important;overflow:hidden!important;color:#1433b7!important;font-size:14px!important;font-weight:650!important;line-height:1.35!important;-webkit-box-orient:vertical!important;-webkit-line-clamp:2!important}',

      '.tn-search-result__meta{display:flex!important;flex-wrap:wrap!important;gap:4px 8px!important;margin-top:4px!important;color:#737d8b!important;font-size:11px!important;line-height:1.3!important}',

      '.tn-search-result__price{text-align:right!important;color:#e20b0b!important;font-size:15px!important;font-weight:700!important;white-space:nowrap!important}',

      '.tn-search-result__availability{display:block!important;margin-top:3px!important;color:#238344!important;font-size:10px!important;font-weight:600!important}',

      '.tn-search-result__availability.is-unavailable{color:#8a929e!important}',

      '.tn-search-all{display:block!important;padding:13px 16px!important;border-top:1px solid #e5eaf2!important;background:#f8faff!important;color:#1433b7!important;font-size:13px!important;font-weight:700!important;text-align:center!important;text-decoration:none!important}',

      '.tn-search-all:hover{background:#eef3ff!important}',

      '@media(max-width:640px){.tn-search-results{top:100%!important;left:0!important;right:0!important;border-radius:0 0 10px 10px!important;max-height:68vh!important}.tn-search-result{grid-template-columns:54px minmax(0,1fr)!important;gap:10px!important;padding:10px 12px!important}.tn-search-result__image{width:54px!important;height:54px!important}.tn-search-result__price{grid-column:2!important;text-align:left!important;margin-top:-7px!important;font-size:14px!important}.tn-search-heading{padding-left:12px!important}.tn-search-all{padding:12px!important}}'
    ].join('');

    document.head.appendChild(estilos);
  }

  function asegurarCampoOculto(
    formulario,
    nombre,
    valor
  ) {
    var campo = formulario.querySelector(
      'input[name="' + nombre + '"]'
    );

    if (!campo) {
      campo = document.createElement('input');
      campo.type = 'hidden';
      campo.name = nombre;
      formulario.appendChild(campo);
    }

    campo.value = valor;
  }

  function formatearPrecio(valor) {
    var numero = Number(valor);

    if (!isFinite(numero)) {
      return '';
    }

    return (
      'L ' +
      numero.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    );
  }

  function obtenerImagen(producto) {
    if (
      producto.featured_image &&
      producto.featured_image.url
    ) {
      return producto.featured_image.url;
    }

    return producto.image || '';
  }

  function obtenerRaizShopify() {
    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function crearEstado(texto) {
    var estado = document.createElement('div');

    estado.className = 'tn-search-status';
    estado.textContent = texto;

    return estado;
  }

  function iniciarFormularioBusqueda(
    formulario,
    indice
  ) {
    if (
      formulario.getAttribute(
        'data-tn-search-ready'
      ) === 'true'
    ) {
      return;
    }

    var campo = formulario.querySelector(
      '.search-bar__input[name="q"], input[name="q"]'
    );

    if (!campo) return;

    var resultados = formulario.querySelector(
      '.search-bar__results-inner'
    );

    if (!resultados) {
      resultados = document.createElement('div');

      resultados.className =
        'search-bar__results-inner';

      var zonaSuperior = formulario.querySelector(
        '.search-bar__top'
      );

      (zonaSuperior || formulario).appendChild(
        resultados
      );
    }

    formulario.setAttribute(
      'data-tn-search-ready',
      'true'
    );

    formulario.classList.add('tn-search-form');

    resultados.classList.add(
      'tn-search-results'
    );

    resultados.id =
      'tn-search-results-' + indice;

    resultados.setAttribute(
      'role',
      'listbox'
    );

    campo.setAttribute(
      'placeholder',
      'Buscar producto...'
    );

    campo.setAttribute(
      'autocomplete',
      'off'
    );

    campo.setAttribute(
      'role',
      'combobox'
    );

    campo.setAttribute(
      'aria-autocomplete',
      'list'
    );

    campo.setAttribute(
      'aria-controls',
      resultados.id
    );

    campo.setAttribute(
      'aria-expanded',
      'false'
    );

    asegurarCampoOculto(
      formulario,
      'type',
      'product'
    );

    asegurarCampoOculto(
      formulario,
      'options[prefix]',
      'last'
    );

    asegurarCampoOculto(
      formulario,
      'options[unavailable_products]',
      'last'
    );

    var temporizador = null;
    var controlador = null;
    var indiceActivo = -1;

    function mostrar() {
      resultados.classList.add(
        'is-visible'
      );

      campo.setAttribute(
        'aria-expanded',
        'true'
      );
    }

    function ocultar() {
      resultados.classList.remove(
        'is-visible'
      );

      campo.setAttribute(
        'aria-expanded',
        'false'
      );

      indiceActivo = -1;
    }

    function limpiar() {
      resultados.innerHTML = '';
      ocultar();
    }

    function mostrarEstado(texto) {
      resultados.innerHTML = '';

      resultados.appendChild(
        crearEstado(texto)
      );

      mostrar();
    }

    function activarResultado(
      enlaces,
      nuevoIndice
    ) {
      for (
        var i = 0;
        i < enlaces.length;
        i += 1
      ) {
        enlaces[i].classList.remove(
          'is-active'
        );

        enlaces[i].setAttribute(
          'aria-selected',
          'false'
        );
      }

      indiceActivo = nuevoIndice;

      if (
        indiceActivo >= 0 &&
        enlaces[indiceActivo]
      ) {
        enlaces[indiceActivo].classList.add(
          'is-active'
        );

        enlaces[indiceActivo].setAttribute(
          'aria-selected',
          'true'
        );

        enlaces[indiceActivo].scrollIntoView({
          block: 'nearest'
        });
      }
    }

    function renderizar(
      productos,
      termino
    ) {
      resultados.innerHTML = '';
      indiceActivo = -1;

      if (!productos.length) {
        resultados.appendChild(
          crearEstado(
            'No encontramos productos para “' +
              termino +
              '”.'
          )
        );

        mostrar();
        return;
      }

      var encabezado =
        document.createElement('div');

      encabezado.className =
        'tn-search-heading';

      encabezado.textContent =
        'Productos encontrados';

      resultados.appendChild(
        encabezado
      );

      var lista =
        document.createElement('div');

      lista.className =
        'tn-search-list';

      lista.setAttribute(
        'role',
        'presentation'
      );

      for (
        var i = 0;
        i < productos.length;
        i += 1
      ) {
        var producto = productos[i];

        var enlace =
          document.createElement('a');

        enlace.className =
          'tn-search-result';

        enlace.href = producto.url;

        enlace.setAttribute(
          'role',
          'option'
        );

        enlace.setAttribute(
          'aria-selected',
          'false'
        );

        var imagen =
          document.createElement('img');

        imagen.className =
          'tn-search-result__image';

        imagen.alt =
          producto.title || 'Producto';

        imagen.loading = 'lazy';

        var direccionImagen =
          obtenerImagen(producto);

        if (direccionImagen) {
          imagen.src = direccionImagen;
        }

        var contenido =
          document.createElement('div');

        contenido.className =
          'tn-search-result__content';

        var titulo =
          document.createElement('div');

        titulo.className =
          'tn-search-result__title';

        titulo.textContent =
          producto.title || 'Producto';

        contenido.appendChild(titulo);

        var metadatos =
          document.createElement('div');

        metadatos.className =
          'tn-search-result__meta';

        if (producto.vendor) {
          var marca =
            document.createElement('span');

          marca.textContent =
            producto.vendor;

          metadatos.appendChild(marca);
        }

        if (
          producto.type &&
          producto.type !== producto.vendor
        ) {
          var tipo =
            document.createElement('span');

          tipo.textContent =
            producto.type;

          metadatos.appendChild(tipo);
        }

        if (
          metadatos.childNodes.length
        ) {
          contenido.appendChild(
            metadatos
          );
        }

        var precio =
          document.createElement('div');

        precio.className =
          'tn-search-result__price';

        var precioProducto =
          producto.price_min !== undefined
            ? producto.price_min
            : producto.price;

        if (
          producto.price_min !== undefined &&
          producto.price_max !== undefined &&
          Number(producto.price_max) >
            Number(producto.price_min)
        ) {
          precio.textContent =
            'Desde ' +
            formatearPrecio(
              precioProducto
            );
        } else {
          precio.textContent =
            formatearPrecio(
              precioProducto
            );
        }

        var disponibilidad =
          document.createElement('span');

        disponibilidad.className =
          'tn-search-result__availability';

        disponibilidad.textContent =
          producto.available
            ? 'Disponible'
            : 'Agotado';

        if (!producto.available) {
          disponibilidad.classList.add(
            'is-unavailable'
          );
        }

        precio.appendChild(
          disponibilidad
        );

        enlace.appendChild(imagen);
        enlace.appendChild(contenido);
        enlace.appendChild(precio);
        lista.appendChild(enlace);
      }

      resultados.appendChild(lista);

      var verTodos =
        document.createElement('a');

      verTodos.className =
        'tn-search-all';

      verTodos.href =
        obtenerRaizShopify() +
        'search?q=' +
        encodeURIComponent(termino) +
        '&type=product&options%5Bprefix%5D=last';

      verTodos.textContent =
        'Ver todos los resultados para “' +
        termino +
        '”';

      resultados.appendChild(
        verTodos
      );

      mostrar();
    }

    function buscar(termino) {
      var clave =
        termino.toLowerCase();

      if (cache[clave]) {
        renderizar(
          cache[clave],
          termino
        );

        return;
      }

      if (controlador) {
        controlador.abort();
      }

      controlador =
        new AbortController();

      mostrarEstado(
        'Buscando productos...'
      );

      var parametros =
        new URLSearchParams();

      parametros.set(
        'q',
        termino
      );

      parametros.set(
        'resources[type]',
        'product'
      );

      parametros.set(
        'resources[limit]',
        String(LIMITE_RESULTADOS)
      );

      parametros.set(
        'resources[options][unavailable_products]',
        'last'
      );

      parametros.set(
        'resources[options][fields]',
        [
          'title',
          'product_type',
          'vendor',
          'tag',
          'variants.title',
          'variants.sku',
          'variants.barcode',
          'body'
        ].join(',')
      );

      var url =
        obtenerRaizShopify() +
        'search/suggest.json?' +
        parametros.toString();

      fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        },
        signal: controlador.signal
      })
        .then(function (respuesta) {
          if (!respuesta.ok) {
            throw new Error(
              'Error de búsqueda: ' +
                respuesta.status
            );
          }

          return respuesta.json();
        })
        .then(function (datos) {
          var productos = [];

          if (
            datos &&
            datos.resources &&
            datos.resources.results &&
            datos.resources.results.products
          ) {
            productos =
              datos.resources.results.products;
          }

          cache[clave] = productos;

          renderizar(
            productos,
            termino
          );
        })
        .catch(function (error) {
          if (
            error.name === 'AbortError'
          ) {
            return;
          }

          console.error(
            'Error en búsqueda predictiva TECNOVA:',
            error
          );

          mostrarEstado(
            'No pudimos cargar sugerencias. Presiona Enter para buscar.'
          );
        });
    }

    campo.addEventListener(
      'input',
      function () {
        var termino =
          campo.value.trim();

        window.clearTimeout(
          temporizador
        );

        if (
          termino.length <
          MINIMO_CARACTERES
        ) {
          if (controlador) {
            controlador.abort();
          }

          limpiar();
          return;
        }

        temporizador =
          window.setTimeout(
            function () {
              buscar(termino);
            },
            ESPERA_BUSQUEDA
          );
      }
    );

    campo.addEventListener(
      'focus',
      function () {
        if (
          campo.value.trim().length >=
            MINIMO_CARACTERES &&
          resultados.childNodes.length
        ) {
          mostrar();
        }
      }
    );

    campo.addEventListener(
      'keydown',
      function (evento) {
        var enlaces =
          resultados.querySelectorAll(
            '.tn-search-result'
          );

        if (
          evento.key ===
            'ArrowDown' &&
          enlaces.length
        ) {
          evento.preventDefault();

          activarResultado(
            enlaces,
            indiceActivo <
              enlaces.length - 1
              ? indiceActivo + 1
              : 0
          );
        } else if (
          evento.key ===
            'ArrowUp' &&
          enlaces.length
        ) {
          evento.preventDefault();

          activarResultado(
            enlaces,
            indiceActivo > 0
              ? indiceActivo - 1
              : enlaces.length - 1
          );
        } else if (
          evento.key === 'Enter' &&
          indiceActivo >= 0 &&
          enlaces[indiceActivo]
        ) {
          evento.preventDefault();

          window.location.href =
            enlaces[indiceActivo].href;
        } else if (
          evento.key === 'Escape'
        ) {
          ocultar();
        }
      }
    );

    var botonLimpiar =
      formulario.querySelector(
        '[data-action="clear-input"]'
      );

    if (botonLimpiar) {
      botonLimpiar.addEventListener(
        'click',
        function () {
          campo.value = '';
          limpiar();
          campo.focus();
        }
      );
    }

    formulario.addEventListener(
      'submit',
      function (evento) {
        if (!campo.value.trim()) {
          evento.preventDefault();
          campo.focus();
        }
      }
    );

    document.addEventListener(
      'click',
      function (evento) {
        if (
          !formulario.contains(
            evento.target
          )
        ) {
          ocultar();
        }
      }
    );
  }

  function iniciarBusquedaTecnoNova() {
    agregarEstilos();

    var formularios =
      document.querySelectorAll(
        'form.search-bar'
      );

    for (
      var i = 0;
      i < formularios.length;
      i += 1
    ) {
      iniciarFormularioBusqueda(
        formularios[i],
        i + 1
      );
    }
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      iniciarBusquedaTecnoNova
    );
  } else {
    iniciarBusquedaTecnoNova();
  }
})();
